module.exports = __webpack_public_path__ + "media/domenj/img__Form__Suggets-93b686d4.png";